module.exports = __webpack_public_path__ + "static/media/banner-img.fe387c18.svg";